<template>
  <b-tab title="AZ Ürünleri">
    <b-row>
      <b-col cols="12" class="text-right">
        <b-button variant="info" size="sm" @click="azMatching(product.id )">AZ SKU Ekle</b-button>
      </b-col>
    </b-row>
    <b-row class="border">
      <b-col cols="2">
        id
      </b-col>
      <b-col cols="2">
        Durum
      </b-col>
      <b-col cols="2">
        Resim
      </b-col>
      <b-col cols="2">
        Az Sku
      </b-col>
    </b-row>
    <b-row v-for="azProduct in azProducts" :key="azProduct.id" class="border">
      <b-col cols="2">
        {{ azProduct.id }} <a :href="'https://www.amazon.com.tr/gp/product/'+azProduct.merchant_sku" target="newTab">
        <feather-icon icon="HomeIcon"/>
      </a>

      </b-col>
      <b-col cols="2">
        <span v-if="azProduct.pivot.status===0">Onay Bekliyor</span>
        <span v-if="[1,2].includes(azProduct.pivot.status)">Onaylandı</span>
        <span v-if="[3,4].includes(azProduct.pivot.status)">Red Edilmiş</span>
        <span v-if="azProduct.pivot.status===5">Ertelenmiş</span>
      </b-col>
      <b-col cols="2">
        Resim
      </b-col>
      <b-col cols="2">
        {{ azProduct.merchant_sku }}
        <amazon-convert-fba-product
            :merchant-sku="azProduct.merchant_sku"
        />
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import addMpMatching from '@/mixins/addMpMatching'
import AmazonConvertFbaProduct from '@/views/common/AmazonConvertFbaProduct.vue';

export default {
  name: "AzProductTab",
  mixins: [addMpMatching],
  components: {AmazonConvertFbaProduct},
  props: {
    product: {
      type: Object,
      required: true,
    },
    azProducts: {
      type: Array,
      required: true
    }
  }
}
</script>